import { useSearchParams } from "react-router-dom";
import logo from "@/assets/logo_salone_vincente.png";
import { YouTubePlayer } from "@/components/YouTubePlayer";
import { usePageViewTracking } from "@/hooks/usePageViewTracking";
import { TRACKED_STEPS } from "@/config/tracking";
const VideoStep5 = () => {
  usePageViewTracking(TRACKED_STEPS.videoStep5);
  const [searchParams] = useSearchParams();

  console.log('[VideoStep5] URL params:', {
    groupId: searchParams.get("groupId"),
    Id: searchParams.get("Id"),
    fullQueryString: searchParams.toString()
  });

  return <div className="h-screen gradient-subtle flex flex-col p-4">
      <div className="flex-1 flex items-center justify-center">
        <div className="max-w-5xl w-full flex flex-col">
          <div className="flex items-center gap-4 mb-3 animate-fade-in">
            <img src={logo} alt="Salone Vincente" className="w-16 h-16 object-contain animate-float flex-shrink-0" />
            <h1 className="flex-1 text-center text-xl md:text-2xl font-bold bg-gradient-to-r from-primary via-secondary to-primary bg-clip-text text-transparent">ASPETTATIVE</h1>
          </div>

          <div className="relative card p-3 shadow-elegant animate-slide-up">
            <YouTubePlayer videoId="DbUSKwASPi8" />
          </div>
        </div>
      </div>
    </div>;
};
export default VideoStep5;
